import auth from "@store/auth" //eslint-disable-line
import creatives from "@store/creatives" //eslint-disable-line
import products from "@store/products" //eslint-disable-line
import programs from "@store/programs" //eslint-disable-line
import insights from "@store/insights" //eslint-disable-line
import productsReview from "@store/productsReview" //eslint-disable-line
import creativesReview from "@store/creativesReview" //eslint-disable-line
import userReview from "@store/userReview" //eslint-disable-line
import channels from "@store/channels" //eslint-disable-line
import customLinks from "@store/customLinks" //eslint-disable-line
import clients from "@store/clients" //eslint-disable-line
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const modules = {
    auth,
    creatives,
    programs,
    insights,
    products,
    productsReview,
    creativesReview,
    userReview,
    channels,
    customLinks,
    clients,
}

export const store = new Vuex.Store({
    state: {
        config: {
            system_minimum_bid_price: 0,
        },
    },
    getters: {
        systemMinBidPrice: ({ config }) => (config.system_minimum_bid_price / 100).toFixed(2),
    },
    modules,
})
